export const API_URL = "https://api.tylt.money";
